import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";


const stickyDonateButton = () => {
	
	gsap.registerPlugin(ScrollTrigger);

	document.addEventListener('DOMContentLoaded', () => {
		const heroBlock = document.querySelector('.hero-block');
		const stickyButtonContainer = document.querySelector('.sticky-donate-button');
		const stickyButton = document.querySelector('.sticky-donate-button__link');
		const stickyStar = document.querySelector('.donate-star-icon');

		// ScrollTrigger for the sticky button visibility
		if (heroBlock && stickyButtonContainer) {
			// Set the initial state of the button to be hidden
			gsap.set(stickyButtonContainer, { autoAlpha: 0, y: 20 });

			ScrollTrigger.create({
				trigger: heroBlock,
				start: 'bottom-=100 top',
				onEnter: () => gsap.to(stickyButtonContainer, { autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.out' }),
				onLeaveBack: () => gsap.to(stickyButtonContainer, { autoAlpha: 0, y: 20, duration: 0.3, ease: 'power2.in' }),
			});
		}

		// sparkle animation on button hover
		if (stickyButton && stickyStar) {
			let sparkleTimeline;
			let isSparkleActive = false;

			const sparkle = () => {
				if (!isSparkleActive) return;

				sparkleTimeline = gsap
					.timeline()
					.set(stickyStar, { opacity: 0, scale: 0.2 })
					.to(stickyStar, {
						opacity: 1,
						scale: 1.3,
						duration: 0.35,
						ease: "power2.out"
					})
					.to(stickyStar, {
						opacity: 0,
						scale: 0.3,
						duration: 0.5,
						ease: "power1.inOut",
						delay: 0.4,
						onComplete: sparkle
					});
			};

			stickyButton.addEventListener('mouseenter', () => {
				if (sparkleTimeline) sparkleTimeline.kill();
				isSparkleActive = true;
				sparkle();
			});

			stickyButton.addEventListener('mouseleave', () => {
				isSparkleActive = false;
				if (sparkleTimeline) {
					sparkleTimeline.kill();
					// Reset the star to its original state
					gsap.to(stickyStar, {
						opacity: 1,
						scale: 1,
						filter: "brightness(1)",
						duration: 0.8,
						ease: "power2.out"
					});
				}
			});
		}
	});
};

export default stickyDonateButton;
